// extracted by mini-css-extract-plugin
export default {"container":"style_container__mWVlK","content":"style_content__C2DK0","imageBox":"style_imageBox__wG7aF"};